/**
 * WalkAndPunch API
 * This is the WalkAndPunch Service API.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type AvailableTypesEnum = 1 | 2 | 3 | 4 | 5 | 6 | 7;

export const AvailableTypesEnum = {
    NUMBER_1: 1 as AvailableTypesEnum,
    NUMBER_2: 2 as AvailableTypesEnum,
    NUMBER_3: 3 as AvailableTypesEnum,
    NUMBER_4: 4 as AvailableTypesEnum,
    NUMBER_5: 5 as AvailableTypesEnum,
    NUMBER_6: 6 as AvailableTypesEnum,
    NUMBER_7: 7 as AvailableTypesEnum
};